import React, { useEffect, useState, useContext, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import MyContext from "../../MyContext";

import blueTick from "../../images/LandingPageImage/blueTick.svg";
import dropdown from "../../images/LandingPageImage/dropDown.svg";

const PricingSection = () => {
  const { baseUrl, config } = useContext(MyContext);
  const pricingRef = useRef(null);
  const [plans, setPlans] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [sessionID, setSessionID] = useState("");
  const [campaignId, setCampaignId] = useState("");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const session = sessionStorage.getItem("sessionID") || crypto.randomUUID();

    const campaign =
      urlParams.get("campaignid") || sessionStorage.getItem("campaignId");

    sessionStorage.setItem("sessionID", session);
    if (campaign) sessionStorage.setItem("campaignId", campaign);

    setSessionID(session);
    setCampaignId(campaign);
  }, []);

  const fetchSubscriptionPlans = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Entitlement/fetchSubscriptionPlans`,
        {
          userid: "",
          countryCode: "IN",
        },
        config
      );
      setPlans(response.data?.data || []);
    } catch (error) {
      console.error("Pricing API error:", error);
    }
  };

  const trackClick = async (buttonName) => {
    try {
      await axios.post(`${baseUrl}/api/Blog/trackClickHeatMaps`, {
        campaignid: campaignId,
        sessionid: sessionID,
        element: "Button",
        button_name: buttonName,
        pageurl: window.location.href,
        pagename: "Landing Page",
        product: "Anlook",
      });
    } catch (error) {
      console.error("SEO click error", error);
    }
  };

  useEffect(() => {
    if (sessionID) {
      fetchSubscriptionPlans();
    }
  }, [sessionID]);

  return (
    <div className="bg-white p-5" ref={pricingRef}>
      <h1 className="My-Landing-pricing-title font-size-1 px-2">
        Unlock the Best WhatsApp Business API Pricing with Super
        <br />
        Affordable Plans & Premium Services!
      </h1>

      <div className="d-flex flex-column flex-md-row justify-content-center gap-3 mb-4">
        {[
          "15-days free trial",
          "Cancel anytime",
          "No credit card required",
        ].map((item, index) => (
          <div key={index}>
            <img src={blueTick} width={10} className="me-1" />
            {item}
          </div>
        ))}
      </div>

      <div className="pricing-cards-container pt-4">
        {plans.map((plan) => (
          <div
            key={plan.id}
            className={`pricing-card-wrapper ${
              plan.is_enabled !== "Y" ? "disabled-card" : ""
            }`}
          >
            <div
              className={`pricing-card ${
                plan.plan_name === "Standard" ? "highlight-card" : ""
              }`}
            >
              <div className="pricing-card-header">
                <h3>{plan.plan_name}</h3>
                {plan.plan_name === "Standard" && (
                  <span className="badge">Most Popular</span>
                )}
              </div>

              <div className="pricing-card-body">
                <div className="price">
                  {plan.currency === "INR" ? "₹" : "$"}
                  {Number(plan.plan_price).toFixed(0)}
                  <span className="price-duration ps-1">
                    {plan.plan_duration}
                  </span>
                </div>

                {plan.is_setup_fee_applicable === "Y" && (
                  <p className="setup-cost-note">
                    + One-time setup fee {plan.currency === "INR" ? "₹" : "$"}
                    {Number(plan.setup_fee).toFixed(0)}
                  </p>
                )}

                <p className="description">{plan.plan_desc}</p>

                <div className="d-flex justify-content-center">
                  <Link
                    to="/get/BuyPlan"
                    state={{ plan, countryCode: "IN" }}
                    className="buy-button text-decoration-none"
                    onClick={() => trackClick("Buy Plan")}
                  >
                    {plan.button_text} →
                  </Link>
                </div>

                {/* FEATURES */}
                <div className="feature-list pt-3">
                  {plan.features
                    .filter((f) => f.status === "Y")
                    .slice(0, showMore ? plan.features.length : 6)
                    .map((feature, index) => (
                      <p key={index} className="feature-item">
                        <img src={blueTick} alt="" />
                        {feature.feature_name}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SHOW MORE */}
      <div className="d-flex justify-content-center py-5">
        <button
          onClick={() => setShowMore(!showMore)}
          className="gray-button bg-white"
          style={{ border: "1px solid #ccc", borderRadius: "20px" }}
        >
          {showMore ? "View less details" : "View all Feature details"}
          <img src={dropdown} className="ms-2" />
        </button>
      </div>
    </div>
  );
};

export default PricingSection;
